import { bigPictureCta as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';
import { BigPictureCtaSectionProps } from '.';

const TestData: BigPictureCtaSectionProps = {
  bigPictureCta: {
    fields: {
      header: 'Header',
      eyebrow: 'Eyebrow',
      richText: 'Rich Text',
      ctaText: 'CTA Text',
      ctaUrl: 'https://example.com',
      img: 'https://example.com/image.jpg',
      img2: 'https://example.com/image2.jpg',
      buttonExternalOption: true,
    },
  },
  statisticGroup: {
    fields: {
      header: 'Statistic Group Header',
      statistics: [
        {
          fields: {
            select: [
              {
                fields: {
                  count: 100,
                  title: 'Statistic 1',
                },
              },
              {
                fields: {
                  count: 200,
                  title: 'Statistic 2',
                },
              },
            ],
          },
        },
      ],
    },
  },
  storyContentNested: {
    fields: {
      eyebrow: 'Nested Eyebrow',
      header: 'Nested Header',
      img: {
        fields: {
          file: {
            url: 'https://example.com/nested-image.jpg',
          },
        },
      },
      bodyText: 'Nested Body Text',
      ctaText: 'Nested CTA Text',
      ctaUrl: 'https://example.com/nested-cta',
    },
  },
};

export default fakeProps(schema, TestData);
